import { createAction, props } from '@ngrx/store';
import { SpecialPrice } from '@core/models'
import { IResponseBadRequest } from '@core/interfaces';

export const SPECIAL_PRICE_FIND_ALL = createAction('[Special Price] Find All');

export const SPECIAL_PRICE_FIND_SUCCESS = createAction('[Special Price] Find Success', props<{ specialPrice: SpecialPrice }>());
export const SPECIAL_PRICE_FIND_ALL_SUCCESS = createAction('[Special Price] Find All Success', props<{ specialPriceList: SpecialPrice[] }>());

export const SPECIAL_PRICE_FAILURE = createAction('[Special Price] Failure', props<{ error: IResponseBadRequest }>());

export const SPECIAL_PRICE_UPDATE_LOADING = createAction('[Special Price] Update Loading', props<{ loading: boolean }>());

export const SPECIAL_PRICE_RESET = createAction('[Special Price] Reset');
export const SPECIAL_PRICE_RESET_ERROR = createAction('[Special Price] Reset Error');
export const SPECIAL_PRICE_CLEAR_STATE = createAction('[Special Price] Clear State');
